import { DateTime } from 'luxon';
import { useCallback, useEffect, useState } from 'react';

export const useCountdown = (
  scheduledTime: DateTime
): {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  complete: boolean;
} => {
  const [update, forceUpdate] = useState(true);

  const isCountdownComplete = useCallback(
    () => scheduledTime.diffNow().milliseconds < 0,
    [scheduledTime]
  );

  const [complete, setComplete] = useState(isCountdownComplete());

  useEffect(() => {
    const interval = setInterval(() => {
      if (isCountdownComplete()) {
        setComplete(true);
        clearInterval(interval);

        return;
      }

      forceUpdate(!update);
    }, 1000);

    return (): void => {
      clearInterval(interval);
    };
  }, [isCountdownComplete, scheduledTime, update]);

  const { days, hours, minutes, seconds } = scheduledTime.diff(DateTime.now(), [
    'hours',
    'days',
    'minutes',
    'seconds'
  ]);

  return {
    days,
    hours,
    minutes,
    seconds: Math.round(seconds),
    complete
  };
};
